'use strict';

var _ = require('underscore');

var HACKATHONS = [
["apphack2014", "AppHack 2014"],
["apphack2015", "AppHack 2015"],
["baybithack2014", "Bay BitHack 2014"],
["bigredhacks2014", "BigRed//Hacks 2014"],
["bitcamp2014", "Bitcamp 2014"],
["bitcamp2015", "Bitcamp 2015"],
["boilermake2014f", "BoilerMake 2014 (Fall)"],
["boilermake2014w", "BoilerMake 2014 (Winter)"],
["brickhack2015", "BrickHack 2015"],
["calhacks2014", "Cal Hacks 2014"],
["carlhacks2015", "CarlHacks 2015"],
["cbbhacks2015", "CBBhacks 2015"],
["citrushack2014", "Citrus Hack 2014"],
["codered2015", "CodeRED 2015"],
["deltahacks2015", "deltaHacks 2015"],
["designhack2014", "Design & Hack 2014"],
["dragonhacks2015", "Dragon Hacks 2015"],
["dubhacks2014", "Dubhacks 2014"],
["emoryhackathon2014", "Emory Hackathon 2014"],
["fashiontechhackathon2015", "Fashion / Tech Hackathon 2015"],
["fixit2015", "#FixIt 2015"],
["geauxhack2014", "GeauxHack 2014"],
["hackarizona2015", "Hack Arizona 2015"],
["hackbeanpot2014", "Hack Beanpot 2014"],
["hackbrown2014", "Hack@Brown 2014"],
["hackbrown2015", "Hack@Brown 2015"],
["hackbu2014", "HackBU 2014"],
["hackbu2015", "HackBU 2015"],
["hackcc2014", "HackCC 2014"],
["hackcooper2014", "Hack Cooper 2014"],
["hackcooper2015", "hackCooper 2015"],
["hackcu2015", "HackCU 2015"],
["hackcuu2015", "HackCUU 2015"],
["hackcwru2015", "HackCWRU 2015"],
["hackdartmouth2015", "HackDartmouth 2015"],
["hackdfw2015", "HackDFW 2015"],
["hackduke2014f", "HackDuke 2014 (Fall)"],
["hackduke2014w", "HackDuke 2014 (Winter)"],
["hackerbowl2014", "Hacker Bowl 2014"],
["hackfsu2014", "HackFSU 2014"],
["hackfsu2015", "HackFSU 2015"],
["hackgt2014", "HackGT 2014"],
["hackhers2015", "Hackhers 2015"],
["hackholyoke2014", "HackHolyoke 2014"],
["hackholyoke2015", "HackHolyoke 2015"],
["hackillinois2014", "HackIllinois 2014"],
["hackillinois2015", "HackIllinois 2015"],
["hackisu2014", "HackISU 2014"],
["hackisu2015", "HackISU 2015"],
["hackmit2014", "HackMIT 2014"],
["hackmizzou2014", "Hack Mizzou 2014"],
["hackmty2015", "HackMTY 2015"],
["hacknc2014f", "HackNC 2014 (Fall)"],
["hacknc2014w", "HackNC 2014 (Winter)"],
["hacknjit2014", "HackNJIT 2014"],
["hackny2014f", "hackNY 2014 (Winter)"],
["hackny2014w", "hackNY 2014 (Winter)"],
["hackny2015", "HackNY 2015"],
["hackpoly2014", "Hack Poly 2014"],
["hackpoly2015", "Hackpoly 2015"],
["hackpr2014f", "HackPR 2014 (Fall)"],
["hackpr2014w", "HackPR 2014 (Winter)"],
["hackprinceton2014f", "HackPrinceton 2014 (Fall)"],
["hackprinceton2014w", "HackPrinceton 2014 (Winter)"],
["hackprinceton2015w", "HackPrinceton 2015 (Winter)"],
["hackpsu2014", "HackPSU 2014"],
["hackpsu2015", "HackPSU 2015"],
["hackrice2014", "Hack.Rice 2014"],
["hackrice2015", "Hack.Rice 2015"],
["hackrpi2014", "HackRPI 2014"],
["hackru2014f", "HackRU 2014 (Fall)"],
["hackru2014w", "HackRU 2014 (Winter)"],
["hackru2015w", "HackRU 2015 (Winter)"],
["hacksc2014f", "HackSC 2014 (Fall)"],
["hacksc2014w", "HackSC 2014 (Winter)"],
["hacksmith2015", "Hack@Smith 2015"],
["hacktcnj2014", "HackTCNJ 2014"],
["hacktcnj2015", "HackTCNJ 2015"],
["hacktech2014", "HackTech 2014"],
["hackthenorth2014", "Hack the North 2014"],
["hacktheplanet2015", "HackThePlanet 2015"],
["hacktx2014", "HackTX 2014"],
["hackuci2014", "HackUCI 2014"],
["hackumass2014", "HackUMass 2014"],
["hackumass2015", "HackUMass 2015"],
["hackumbc2014", "HackUMBC 2014"],
["hackuva2014", "HackUVA 2014"],
["hackuva2015", "Hack.UVA 2015"],
["hackuwin2014", "HackUWin 2014"],
["hackwestern2015", "Hack Western 2015"],
["hackysu2015", "HackYSU 2015"],
["hophacks2014f", "HopHacks 2014 (Fall)"],
["hophacks2014w", "Hop Hacks 2014 (Winter)"],
["hophacks2015w", "HopHacks 2015 (Winter)"],
["idhack2015", "ID Hack 2015"],
["kenthackenough2014", "Kent Hack Enough 2014"],
["lahacks2014", "LA Hacks 2014"],
["localhackday2014", "LocalHackDay 2014"],
["madhacks2015", "MadHacks 2015"],
["makecu2015", "MakeCU 2015"],
["makemit2014", "MakeMIT 2014"],
["mchacks2014", "McHacks 2014"],
["mchacks2015", "McHacks 2015"],
["medstart2015", "Medstart 2015"],
["mhacks2013", "MHacks 2013"],
["mhacks2014f", "MHacks 2014 (Fall)"],
["mhacks2014w", "MHacks 2014 (Winter)"],
["mhacks2015w", "MHacks 2015 (Winter)"],
["mxhacks2015", "MXHacks 2015"],
["pearlhacks2014", "Pearl Hacks 2014"],
["pearlhacks2015", "PearlHacks 2015"],
["pennapps2014", "PennApps 2014"],
["pennapps2015", "PennApps 2015"],
["pennappsx2014", "PennApps X 2014"],
["project342015", "Project 34 2015"],
["ramhacks2014", "RamHacks 2014"],
["redbirdhacks2015", "RedbirdHacks 2015"],
["revolutionuc2014f", "RevolutionUC 2014 (Fall)"],
["revolutionuc2014w", "Revolution UC 2014 (Winter)"],
["revolutionuc2015w", "RevolutionUC 2015 (Winter)"],
["sbhacks2015", "SBHacks 2015"],
["spartahack2015", "SpartaHack 2015"],
["steelhacks2015", "SteelHacks 2015"],
["tamuhack2014", "TAMUHack 2014"],
["tartanhacks2014", "TartanHacks 2014"],
["treehacks2015", "TreeHacks 2015"],
["tribehacks2014", "TribeHacks 2014"],
["uhack2015", "UHack 2015"],
["unhackathon2014", "Unhackathon 2014"],
["uofthacks2015", "UofTHacks 2015"],
["vandyhacks2015", "VandyHacks 2015"],
["vthacks2014", "VTHacks 2014"],
["vthacks2015", "VTHacks 2015"],
["wildhacks2014", "Wildhacks 2014"],
];


var hackathons = _.map(HACKATHONS, function(e) { return e[1]; });
var lowerCaseHackathons = _.map(hackathons, function(e) { return e.toLowerCase(); });
var lowerCaseHackathonsMapping = _.chain(hackathons).map(function(e) { return [e.toLowerCase(), e]; }).object().value();
// WARNING: can't use e.reverse() because it mutates the original data array above :(
var hackathonToSlugMapping = _.chain(HACKATHONS).map(function (e) { return [e[1], e[0]]; }).object().value();
var slugToHackathonMapping = _.chain(HACKATHONS).object().value();

module.exports = {
    hackathons: hackathons,
    lowerCaseHackathons: lowerCaseHackathons,
    lowerCaseHackathonsMapping: lowerCaseHackathonsMapping,
    hackathonToSlugMapping: hackathonToSlugMapping,
    slugToHackathonMapping: slugToHackathonMapping,
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/events.js
 ** module id = 240
 ** module chunks = 0 1 6 9
 **/